import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  CustomDropDownFacing,
  CustomDropdownOptionModel,
} from '@shared/components/custom-dropdown/custom-dropdown-option.model';

@Component({
  selector: 'od-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss'],
  standalone: false,
})
export class CustomDropdownComponent implements OnChanges {
  CustomDropDownFacing = CustomDropDownFacing;
  @ViewChild('dropdown') public dropdown: ElementRef;

  @Input() options: CustomDropdownOptionModel[] = [];
  @Input() cols: number = 1;
  @Input() facing: CustomDropDownFacing = CustomDropDownFacing.DOWN;
  @Input() placeholder: string = '';
  @Output() selectedOption$: EventEmitter<CustomDropdownOptionModel> =
    new EventEmitter<CustomDropdownOptionModel>();
  isOpen: boolean = false;

  public groupedOptions: CustomDropdownOptionModel[][] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['options'] &&
      changes['options'].currentValue &&
      changes['cols'] &&
      changes['cols'].currentValue
    ) {
      for (let i = 0; i < this.cols; i++) {
        this.groupedOptions[i] = [];
      }
      const colSize = this.options.length / this.cols;
      for (let i = 0; i < this.options.length; i++) {
        this.groupedOptions[Math.floor(i / colSize)].push(this.options[i]);
      }
    }
  }

  @HostListener('document:pointerup', ['$event', '$event.target'])
  pointerUp(_event: MouseEvent, targetElement: HTMLElement) {
    if (!this.dropdown?.nativeElement.contains(targetElement) && this.isOpen) {
      this.isOpen = false;
    }
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: CustomDropdownOptionModel): void {
    this.selectedOption$.emit(option);
    this.isOpen = false;
  }
}
